<!-- Backdrop -->
<div class="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
     (click)="close()">
  <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

  <!-- Sheet -->
  <div class="relative w-full sm:max-w-sm rounded-t-2xl sm:rounded-2xl bg-white dark:bg-gray-900 shadow-2xl"
       (click)="$event.stopPropagation()">

    <!-- Handle (mobile) -->
    <div class="flex justify-center pt-3 pb-1 sm:hidden">
      <div class="w-10 h-1 rounded-full bg-gray-300 dark:bg-gray-700"></div>
    </div>

    <!-- Header -->
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-800">
      <div>
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Share</h3>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate max-w-[220px]">{{ config.title }}</p>
      </div>
      <div class="flex items-center gap-3">
        <!-- Share count -->
        <div class="flex items-center gap-1 px-2.5 py-1 rounded-full bg-gray-100 dark:bg-gray-800">
          <svg class="h-3.5 w-3.5 text-[#D31148]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.79 12.61C21.04 12.4 21.16 12.29 21.2 12.17C21.24 12.06 21.24 11.94 21.2 11.83C21.16 11.71 21.04 11.6 20.79 11.39L12.32 4.13C11.9 3.77 11.69 3.59 11.51 3.59C11.36 3.58 11.21 3.65 11.11 3.77C11 3.91 11 4.19 11 4.74V9.03C8.87 9.41 6.91 10.49 5.46 12.11C3.88 13.88 3 16.18 3 18.55V19.16C4.05 17.9 5.36 16.88 6.84 16.17C8.15 15.54 9.56 15.17 11 15.07V19.26C11 19.81 11 20.09 11.11 20.23C11.21 20.35 11.36 20.42 11.51 20.41C11.69 20.41 11.9 20.23 12.32 19.87L20.79 12.61Z"/>
          </svg>
          <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">{{ currentCount }}</span>
        </div>
        <button (click)="close()"
          class="flex h-7 w-7 items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 transition-colors">
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Platform grid -->
    <div class="grid grid-cols-4 gap-x-3 gap-y-4 p-5">
      <button *ngFor="let p of platforms"
        (click)="share(p.id)"
        class="flex flex-col items-center gap-2 group outline-none">
        <div class="w-12 h-12 rounded-full flex items-center justify-center shadow-sm transition-transform group-hover:scale-110 group-active:scale-95 overflow-hidden"
          [style.background-color]="p.id === 'copy' && copied ? '#22c55e' : p.bg">
          <!-- normal icon -->
          <svg *ngIf="!(p.id === 'copy' && copied)" class="w-12 h-12" viewBox="0 0 24 24"
               [innerHTML]="p.svgContent">
          </svg>
          <!-- copy success tick -->
          <svg *ngIf="p.id === 'copy' && copied" class="w-5 h-5 text-white" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <span class="text-xs text-gray-600 dark:text-gray-400 font-medium text-center leading-tight w-14 truncate">
          {{ p.id === 'copy' && copied ? 'Copied!' : p.label }}
        </span>
      </button>
    </div>

    <!-- URL bar -->
    <div class="mx-5 mb-5 flex items-center gap-2 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 px-3 py-2.5">
      <svg class="h-4 w-4 text-gray-400 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
      </svg>
      <span class="text-xs text-gray-500 dark:text-gray-400 flex-1 truncate">{{ contentUrl }}</span>
      <button (click)="share('copy')"
        class="text-xs font-semibold flex-shrink-0 transition-colors"
        [class.text-green-500]="copied"
        [class.text-[#D31148]]="!copied">
        {{ copied ? 'Copied!' : 'Copy' }}
      </button>
    </div>

  </div>
</div>
